module.exports = {"220722100":"长岭镇","220722101":"太平川镇","220722102":"巨宝山镇","220722103":"太平山镇","220722104":"前七号镇","220722105":"新安镇","220722106":"三青山镇","220722107":"大兴镇","220722108":"北正镇","220722109":"流水镇","220722110":"永久镇","220722111":"利发盛镇","220722123":"长岭经济开发区（特殊乡镇）","220722200":"集体乡","220722201":"光明乡","220722202":"三县堡乡","220722203":"海青乡","220722204":"前进乡","220722205":"东岭乡","220722206":"腰坨子乡","220722207":"八十八乡","220722208":"三团乡","220722209":"三十号乡","220722400":"长岭种马场","220722405":"太平川机械林场","220722406":"三团机械林场","220722407":"东岭机械林场","220722408":"十四号种畜场","220722409":"良种繁育场","220722410":"前七号机械林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220722.json
// module id = 654
// module chunks = 0